import {createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {CitizensServicesExistanceSource} from './citizens-services-existance-source.model';
import * as CitizensServicesExistanceSourceActions from './citizens-services-existance-source.actions';

export const citizensServicesExistanceSourcesFeatureKey = 'citizensServicesExistanceSources';

export interface State extends EntityState<CitizensServicesExistanceSource> {
  // additional entities state properties
}

export const adapter: EntityAdapter<CitizensServicesExistanceSource> = createEntityAdapter<CitizensServicesExistanceSource>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(CitizensServicesExistanceSourceActions.addCitizensServicesExistanceSource,
    (state, action) => adapter.addOne(action.citizensServicesExistanceSource, state)
  ),
  on(CitizensServicesExistanceSourceActions.upsertCitizensServicesExistanceSource,
    (state, action) => adapter.upsertOne(action.citizensServicesExistanceSource, state)
  ),
  on(CitizensServicesExistanceSourceActions.addCitizensServicesExistanceSources,
    (state, action) => adapter.addMany(action.citizensServicesExistanceSources, state)
  ),
  on(CitizensServicesExistanceSourceActions.upsertCitizensServicesExistanceSources,
    (state, action) => adapter.upsertMany(action.citizensServicesExistanceSources, state)
  ),
  on(CitizensServicesExistanceSourceActions.updateCitizensServicesExistanceSource,
    (state, action) => adapter.updateOne(action.citizensServicesExistanceSource, state)
  ),
  on(CitizensServicesExistanceSourceActions.updateCitizensServicesExistanceSources,
    (state, action) => adapter.updateMany(action.citizensServicesExistanceSources, state)
  ),
  on(CitizensServicesExistanceSourceActions.deleteCitizensServicesExistanceSource,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(CitizensServicesExistanceSourceActions.deleteCitizensServicesExistanceSources,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(CitizensServicesExistanceSourceActions.loadCitizensServicesExistanceSources,
    (state, action) => adapter.setAll(action.citizensServicesExistanceSources, state)
  ),
  on(CitizensServicesExistanceSourceActions.clearCitizensServicesExistanceSources,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
